import * as React from "react";

function HashtagIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M416 127.1h-58.23l9.789-58.74c2.906-17.44-8.875-33.92-26.3-36.83-17.53-2.875-33.92 8.891-36.83 26.3L292.9 127.1h-95.1l9.789-58.74c2.906-17.44-8.875-33.92-26.3-36.83-17.53-2.875-33.92 8.891-36.83 26.3L132.9 127.1H64c-17.67 0-32 14.33-32 32 0 18.6 14.33 32 32 32h58.23l-21.33 128H32c-17.67 0-32 14.33-32 32s14.33 31.1 32 31.1h58.23l-9.789 58.74c-2.906 17.44 8.875 33.92 26.3 36.83C108.5 479.9 110.3 480 112 480c15.36 0 28.92-11.09 31.53-26.73L155.07 384h95.12l-9.789 58.74c-2.906 17.44 8.875 33.92 26.3 36.83 1.799.33 3.599.43 5.299.43 15.36 0 28.92-11.09 31.53-26.73L315.07 384H384c17.67 0 32-14.33 32-31.1 0-17.67-14.33-32-32-32h-58.23l21.33-128H416c17.67 0 32-14.32 32-31.1 0-19.5-14.3-34.7-32-34.7zm-155.1 192h-95.1l21.3-128h95.12l-21.32 128z"
  }));
}

const ForwardRef = React.forwardRef(HashtagIcon);
export default ForwardRef;